import { createBrowserRouter } from 'react-router-dom'
import { lazy } from 'react'
import { MainLayout } from '@/layouts'
import { GameProvider, StudentProvider } from '@/contexts'

// Lazy load components
const Home = lazy(() => import('@/pages/Home/Home'))
const SpinnerPage = lazy(() => import('@/pages/Spinner'))
const GameLeaderboardPage = lazy(() => import('@/pages/GameLeaderboard'))

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,  
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'spinner',
        element: <StudentProvider autoLoad={true}><SpinnerPage /></StudentProvider>
      },
      {
        path: 'game-leaderboard',
        element: (
          <GameProvider>
            <GameLeaderboardPage />
          </GameProvider>
        ),
      }
    ],
  },
])
